module.exports = __webpack_public_path__ + "img/87.e7cc065b.png";